import React from 'react';
import Packages from '../components/Packages';
import FAQ from '../components/FAQ';
import ContactForm from '../components/ContactForm';

export default function PricingPage() {
  return (
    <div className="pt-24 lg:pt-32">
      <div className="bg-slate-900 py-16 mb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight mb-4">
            Priser & <span className="text-sky-500">Pakker</span>
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Find den pakke der passer bedst til dit behov og din bils størrelse. Vi tilbyder gennemsigtige priser uden skjulte gebyrer.
          </p>
        </div>
      </div>
      <Packages />
      <div className="bg-white">
        <FAQ />
      </div>
      <ContactForm />
    </div>
  );
}
